// extracted by css-extract-rspack-plugin
export default {"AnimatedAnnotationIcon":"AnnotationIcon-module__AnimatedAnnotationIcon__GP9yX","fadeIn":"AnnotationIcon-module__fadeIn__s4zAm"};